import { Component, OnInit, ViewChild} from '@angular/core';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {ModalUploadComponent} from '../../modal-upload/modal-upload.component';
import * as decode from 'jwt-decode';

import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  @ViewChild('fileInvView', { static: false }) fileInvView;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  typeFileUpload: any;
  step = 0;
  loadBtn = false;
  checkedAll = false;
  arra = [];
  listReceptions = [];
  arrOc = [];
  listSocieties = [];
  totalSelect = 0;
  total = 0;
  aplicaWorkFlow;
  tipoOrden = 3; 

  providersList=[];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  
  constructor(public translate: TranslateService,private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    gralService.changeTextHead('SERVICES');
    this.getSocieties();
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  addProveedorSearch(option){
    console.log('option', option);
    let value = this.myControl.value;    
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.selectSociety();
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(){
    const society = this.listSocieties.find(x => x.NoSociedad == this.data.society);
    if(society.NumProveedor){
      this.data.provider = society.NumProveedor;
    }
  }

  disabledProv(){
    let resp = false;
    if(this.data.society){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.society);
      if(society.NumProveedor){
        resp = true;
      }
    }
    return resp;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  

  search(){
    if(this.arrOc.length < 1 && !this.data.oc){
      
        let body = "Favor de ingresar un número de orden de compra"
        if(this.translate.currentLang == "en"){
          body = "Please enter a purchase order number";
          
        }else if(this.translate.currentLang == "es"){
          body = "Favor de ingresar un número de orden de compra";
        }
      this.toastr.error(body, 'Error');
      return;
    }

    this.step = 0;
    this.listReceptions = null;
    this.temp = null;
    this.loadBtn = true;

    let params = '';
    if(this.arrOc.length > 0){
      for(let g = 0; g < this.arrOc.length; g++){
        params = params+this.arrOc[g]+',';
      }
      params = params.substring(0, params.length - 1);
    }else{
      params = this.data.oc;
    }

    
    this.provService.searchOC(params, this.data.society, null, this.data.provider, 3, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['PO_Receptions_Available'].length > 0){
        this.listReceptions = data['PO_Receptions_Available'];
        this.temp = data['PO_Receptions_Available'];
        this.aplicaWorkFlow = data['PO_Receptions_Available'][0].AplicaWorkFlow;
        console.log(this.aplicaWorkFlow);
        this.step = 1;
        this.getTotal();
      }else{
        let title = "Ordenes";
        let body = "No existen recepciones disponibles"
        if(this.translate.currentLang == "en"){
          title = "Ordenes";
          body = "There are no receptions available";
          
        }else if(this.translate.currentLang == "es"){
          title = "Orders";
          body = "No existen recepciones disponibles";
        }
        this.toastr.info(body,title);
      }
    }, (err) => {
      console.log(err);
      this.step = 0;
      this.listReceptions = null;
      this.temp = null;
      this.loadBtn = false;
      this.toastr.error('--', 'Error');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectAll(){
    for(let g = 0; g < this.listReceptions.length; g++){
      this.listReceptions[g].select = this.checkedAll;
      this.sumTot();
    }
  }

  subtotalItem(idx){
    this.listReceptions[idx].Importe_Local = this.listReceptions[idx].Cantidad * this.listReceptions[idx].PrecioUnitario;
  }

  uploadFiles(type){
    this.arra = [];
    for(let g = 0; g < this.listReceptions.length; g++){
      if(this.listReceptions[g].select){
        const paramspush = {
          PrecioPorUnidad: this.listReceptions[g].PrecioPorUnidad,
          AnhoRecepcion: this.listReceptions[g].YearDocumento,
          Planta: this.listReceptions[g].Planta,
          Autorizador: this.listReceptions[g].UsuarioAprobador,
          UnidadDeMedida: this.listReceptions[g].Unidad_Medida,
          IdUsuarioSeleccion: 13,
          OrdenCompra: this.listReceptions[g].Orden_Compra,
          NumRecepcion: this.listReceptions[g].Numero_Documento,
          Posicion: this.listReceptions[g].Posicion_OrdenCompra,
          Cantidad: this.listReceptions[g].Cantidad,
          PrecioUnitario: this.listReceptions[g].PrecioUnitario,
          IndicadorDeImpuesto: this.listReceptions[g].Indicador_IVA,
          Moneda: this.listReceptions[g].Moneda,
          Almacen: this.listReceptions[g].Almacen,
          NumSociedad: this.listReceptions[g].Sociedad, 
          CentroDeCosto: this.listReceptions[g].CentroDeCosto,
          OrdenInterna: this.listReceptions[g].OrdenInterna,
          AplicaML81N: this.listReceptions[g].AplicaML81N,
          Posicion_DocumentoRef: this.listReceptions[g].Posicion_DocumentoRef
        };
        this.arra.push(paramspush);
      }
    }

    if(this.arra.length < 1){
      let title = "Cargar factura";
      let body = "Favor de seleccionar por lo menos una recepción"
      if(this.translate.currentLang == "en"){
        title = "Upload invoice";
        body = "Please select at least one reception";
      }else if(this.translate.currentLang == "es"){
        title = "Cargar factura";
        body = "Favor de seleccionar por lo menos una recepción";
      }
      this.toastr.error(body,title);
      return;
    }

    if(this.aplicaWorkFlow){ this.tipoOrden = 3; } else{ this.tipoOrden = 8; }
    const params = {xmlBase64: null, pdfBase64: null, numeroProveedor: this.data.provider, claveEmpresa: 'SMP', tipoOrden: this.tipoOrden, datosOrdenCompra: {listaRecepcionesDisponibles: this.arra}};

    const dialogRef = this.dialog.open(ModalUploadComponent, {
      minWidth: '70%',
      position: {
        top: '6%'
      },
      data: { type: type, data: params, totalSelect: this.totalSelect }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.data = {};
        this.step = 0;
        this.listReceptions = null;
        this.arrOc = [];
        this.temp = null;
        this.checkedAll = false;
      }
    });
  }

  sumTot(){
    let tot = 0;
    for(let g = 0; g < this.listReceptions.length; g++){
      if(this.listReceptions[g].select){
        tot += this.listReceptions[g].Importe_Local;
      }
    }
    this.totalSelect = tot;
  }

  getTotal(){
    setTimeout(() => {
      let tot = 0;
      for(let g = 0; g < this.listReceptions.length; g++){
        tot += this.listReceptions[g].Importe_Local;
      }
      this.total = tot;
    }, 500);
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }

}
